<div class='table_center' *ngIf="options.length">
  <div class="drop-down {{openDropDawnOptions?'drop-down--active':''}}">
    <div class='drop-down__button text-normal' (click)='toggleDropDawnOptions()'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" width="24" height="24" fill="currentColor">
            <path d="M96 184c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40zm0 72c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zm0 152c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40z"/>
        </svg>

    </div>

    <div class='drop-down__menu-box' [style]='menuBoxStyle'>
      <ul class='drop-down__menu'>
        <li data-name='profile' class='drop-down__item' *ngFor='let option of options; let optionIndex = index'
            (click)='select({event: option})'>
          {{option | translate}}
        </li>
      </ul>
    </div>
  </div>
</div>
